import ReturningUsersContext from '../../../common/contexts/ReturningUsers.js';
import Builder from '../../../common/contexts/builders/Builder.js';
import CookieSessionCounter from '../../../common/storage/SessionCounter.js';
import Gateway from '../../../common/Gateway';
import V10DataProvider from './dataProviders/V10DataProvider';
import CookieDataProvider from './dataProviders/CookieDataProvider';

export default class ReturningUsers extends Builder {
  constructor() {
    super();
  }

  isEnabled() {
    return this._isEnabledForV10() || this._isEnabledForCookie();
  }

  setContext(contexts) {
    this._setupContext();
    if(!this.isEmpty())
      contexts.replace(this.context);
  }

  _setupContext() {
    const provider = this._getProvider();

    this.context = new ReturningUsersContext();
    this.context.setData(provider.lastViewedVehicles, provider.hasSearched, provider.sentEnquiries);
  }

  _getProvider() {
    return Gateway.isAutoV10 ? this._getV10Provider() : this._getCookieProvider();
  }

  _getV10Provider() {
    return V10DataProvider;
  }

  _getCookieProvider() {
    return CookieDataProvider;
  }

  _isEnabledForV10() {
    return Gateway.isAutoV10;
  }

  _isEnabledForCookie() {
    const hasData = CookieDataProvider.lastViewedVehicles.length || this._getCookieProvider().hasSearched || CookieDataProvider.sentEnquiries.length;
    return (new CookieSessionCounter()).get() > 1 && hasData;
  }

  set lastViewedVehicles(value) {
    const provider = this._getProvider();
    if(value != null){
      provider.lastViewedVehicles = value;
    }
  }

  set hasSearched(value) {
    const provider = this._getProvider();
    if (value != null) {
      provider.hasSearched = value;
    }
  }

  set sentEnquiries(value) {
    const provider = this._getProvider();
    if (value != null) {
      provider.sentEnquiries = value;
    }
  }
}
